import React from 'react'
import { Form, Input, InputNumber } from 'antd'
import CommonEditSelectComponent from './common-edit-select-component'
import CommonEditImageComponent from './common-edit-image-component'
import CommonEditGoogleMapAddressSelectComponent from './common-edit-google-map-address-select-component'
import CommonEditFixedSelectComponent from './common-edit-fixed-select-componnent'
import CommonEditWithSwitchComponent from './common-edit-with-switch-component'
import PackagingTypeCascadeSelect from '../packaging-type-cascade-select'

console.log('common-edit-component loaded v2.0 - fixed packagingTypeId path')

const { TextArea } = Input

interface CommonEditComponentPropsInterface {
  formItems: any
  restFormItems?: any
  propsFunction: any
}

export interface FormItemPropsInterface {
  label: string
  keyword: string
  value?: any
  type?: string
  required?: boolean
  disabled?: boolean
  selectionGetUrl?: string
  rowDataKeyword?: string
  isNotShow?: boolean
  valueJoinArray?: any
  isOverrideSelectionOptions?: boolean
  width?: string
  exceptionOptionKey?: any
  max?: number
  min?: number
  isNotCutting?: boolean
  options?:any
  maxLength?: number
  showCount?: boolean
}

const CommonEditComponent = (props: CommonEditComponentPropsInterface): any => {
  const propsFn = props.propsFunction

  const inputFormItem = (formItem: FormItemPropsInterface, otherProps?: any) => {
    const inputProps = {
      value: formItem.value,
      allowClear: true,
      autoComplete: 'newpassword',
      style: {width: formItem.width || '12rem'},
      disabled: formItem.disabled,
      maxLength: formItem.maxLength,
      showCount: false, // 始终为 false，我们手动显示计数
      onChange: (e: any) => updateRowData(formItem, otherProps?.type === 'number' ? parseInt(e.target.value, 10) : e.target.value),
      ...otherProps
    }

    const currentLength = formItem.value?.length || 0
    const maxLength = formItem.maxLength

    if (formItem.showCount && maxLength && currentLength > 0) {
      return (
        <div style={{ position: 'relative' }}>
          <Input {...inputProps} />
          <div style={{
            fontSize: '12px',
            color: '#999',
            position: 'absolute',
            right: 0,
            top: '100%',
            marginTop: '2px',
            lineHeight: 1
          }}>
            {currentLength} / {maxLength}
          </div>
        </div>
      )
    }

    return (
      <Input {...inputProps} />
    )
  }
  const fixedSelectFormItem = (formItem: FormItemPropsInterface) => {
    return (
      <CommonEditFixedSelectComponent
        key={formItem.keyword}
        required={formItem.required}
        label={formItem.label}
        disabled={formItem.disabled}
        rowDataKeyword={formItem.rowDataKeyword}
        isOverrideSelectionOptions={formItem.isOverrideSelectionOptions}
        width={formItem.width}
        exceptionOptionKey={formItem.exceptionOptionKey}
        propsFn={propsFn}
        options={formItem.options}
      />
    )
  }
  const selectFormItem = (formItem: FormItemPropsInterface) => {
    return (
      <CommonEditSelectComponent
        key={formItem.keyword}
        urlInfoKey={formItem.keyword}
        required={formItem.required}
        label={formItem.label}
        disabled={formItem.disabled}
        selectionGetUrl={formItem.selectionGetUrl}
        rowDataKeyword={formItem.rowDataKeyword}
        valueJoinArray={formItem.valueJoinArray}
        isOverrideSelectionOptions={formItem.isOverrideSelectionOptions}
        width={formItem.width}
        exceptionOptionKey={formItem.exceptionOptionKey}
        propsFn={propsFn}
      />
    )
  }

  const googleMapAddrSelectFormItem = (formItem: FormItemPropsInterface) => {
    return (
      <CommonEditGoogleMapAddressSelectComponent
        key={formItem.keyword}
        urlInfoKey={formItem.keyword}
        required={formItem.required}
        label={formItem.label}
        disabled={formItem.disabled}
        width={formItem.width}
        propsFn={propsFn}
      />
    )
  }

  const ImageFormItem = (FormItem: FormItemPropsInterface) => {
    return (
      <CommonEditImageComponent
        key={FormItem.keyword}
        formItems={FormItem}
        propsFn={propsFn}
      />
    )
  }

  const inputNumberFormItem = (formItem: FormItemPropsInterface) => {
    const inputNumberProps: any = {
      type: 'number',
      onKeyPress: (e: any) => {
        if (e.key === 'e' || e.key === '-') {
          e.preventDefault()
        }
      }
    }
    return inputFormItem(formItem, inputNumberProps)
  }

  const inputNumberWithRangeFormItem = (formItem: FormItemPropsInterface) => {
    const inputProps = {
      autoComplete: 'newpassword2',
      style: {width: formItem.width || '12rem'},
      disabled: formItem.disabled,
      max: formItem.max || 999999999999,
      min: formItem.min || -999999999999,
      onChange: (value: any) => updateRowData(formItem, value),
    }
    return (
      <InputNumber {...inputProps} />
    )
  }

  const inputTextAreaFormItem = (formItem: FormItemPropsInterface) => {
    const onTextAreaChange: any = (e: any) => updateRowData(formItem, e.target.value)
    return <TextArea style={{width: formItem.width||'16rem'}} showCount autoSize maxLength={300} disabled={formItem.disabled} onChange={onTextAreaChange} />
  }


  const custProductCodeSwitchFormItem = (formItem: FormItemPropsInterface) => {
    return (
      <CommonEditWithSwitchComponent
        value={formItem.value}
        onChange={(value: any) => updateRowData(formItem, value)}
        productCode={propsFn.rowData?.productCode || ''}
        disabled={formItem.disabled}
      />
    )
  }

  const updateRowData = (formItem: FormItemPropsInterface, value: any) => {
    propsFn.onRowDataChange({
      ...propsFn.rowData,
      [formItem.keyword]: value
    })
  }

  const dateFormItem = (formItem: FormItemPropsInterface) => null

  const dateRangeFormItem = (formItem: FormItemPropsInterface) => null

  const packagingTypeCascadeFormItem = (formItem: FormItemPropsInterface) => {
    // 直接从 rowData 获取包装类型ID值（扁平化数据结构）
    const valueKey = formItem.rowDataKeyword || formItem.keyword
    const nestedValue = propsFn.rowData?.[valueKey]

    console.log('PackagingTypeCascadeSelect value DEBUG:', {
      keyword: formItem.keyword,
      rowDataKeyword: formItem.rowDataKeyword,
      valueKey,
      nestedValue,
      'packagingTypeId': propsFn.rowData?.packagingTypeId,
      'packagingType': propsFn.rowData?.packagingType,
      fullRowData: propsFn.rowData
    })

    return (
      <PackagingTypeCascadeSelect
        value={nestedValue}
        onChange={(value: number | null) => {
          console.log('PackagingTypeCascadeSelect onChange:', {
            value,
            oldValue: propsFn.rowData?.packagingTypeId,
            formItem
          })

          // 直接更新 packagingTypeId 字段
          propsFn.onRowDataChange({
            ...propsFn.rowData,
            packagingTypeId: value
          })
        }}
        disabled={formItem.disabled}
      />
    )
  }

  const getFormItem = (formItem: FormItemPropsInterface) => {
    switch (formItem.type) {
      case 'select':
        return selectFormItem(formItem)
      case 'googleMapAddrSelect':
        return googleMapAddrSelectFormItem(formItem)
      case 'inputNumber':
        return formatFormItem(formItem, inputNumberFormItem(formItem))
      case 'inputNumberWithRange':
        return formatFormItem(formItem, inputNumberWithRangeFormItem(formItem))
      case 'inputTextArea':
        return formatFormItem(formItem, inputTextAreaFormItem(formItem))
      case 'date':
        return formatFormItem(formItem, dateFormItem(formItem))
      case 'dateRange':
        return formatFormItem(formItem, dateRangeFormItem(formItem))
      case 'image':
        return ImageFormItem(formItem)
      case 'fixedSelect':
        return fixedSelectFormItem(formItem)
      case 'custProductCodeSwitch':
        return custProductCodeSwitchFormItem(formItem)
      case 'packagingTypeCascadeSelect':
        return packagingTypeCascadeFormItem(formItem)
      default:
        return formatFormItem(formItem, inputFormItem(formItem))
    }
  }

  const formatFormItem = (formItem: FormItemPropsInterface, element: any) => {
    return (
      <Form.Item
        key={formItem.keyword}
        label={formItem.label}
        name={formItem.keyword}
        initialValue={formItem.value != null ? formItem.value : ''}
        rules={[{ required: formItem.required, message: formItem.label + ' is required!' }]}
      >
        {element}
      </Form.Item>
    )
  }

  return (
    <div>
      <Form layout="vertical">
        { props.formItems.map((formItem: FormItemPropsInterface) => !formItem.isNotShow ? getFormItem(formItem) : null) }
        { props.restFormItems ? props.restFormItems.map((formItem: any) => formItem) : null }
      </Form>
    </div>
  )
}

export default CommonEditComponent
